import i18n from '../../managers/i18n'

i18n.register(
  'en-US',
  {
    clear: 'Clear',
    selectDate: 'Select a date',
    selectMonth: 'Select a month',
    selectYear: 'Select a year',
    selectRange: ['Start date', 'End date'],
    selectMonthRange: ['Start month', 'End month'],
    selectYearRange: ['Start year', 'End year']
  },
  {
    ns: 'datepicker'
  }
)
